import ImageWithBasePath from "@/components/image-with-base-path"
import { all_routes } from "@/routes/all_routes"
import { Link } from "react-router"


const BlogSection = () => {
  return (
    <>
  {/* Start Blog Section */}
  <section className="section blog-section-fifteen">
    <div className="container">
      <div
        className="section-header section-header-fifteen text-center wow fadeInUp"
        data-wow-duration="2s"
      >
        <div className="section-sub-title">Our Blog &amp; News</div>
        <h2 className="section-title">
          Discover Trends, Tips, And <br /> <span>Industry News </span>
        </h2>
      </div>
      {/* start row */}
      <div className="row">
        {/* Blog Item 1 */}
        <div className="col-lg-12">
          <div
            className="blog-item-fifteen wow fadeInUp"
            data-wow-duration="2s"
          >
            <div className="blog-img">
              <ImageWithBasePath
                src="assets/img/blog/blog-img-4.jpg"
                alt="blog"
                className="img-fluid"
              />
            </div>
            <div className="blog-content">
              <Link to="#" className="blog-tag">
                Trauma &amp; Recovery
              </Link>
              <h3 className="blog-title">
                <Link to={all_routes.blogDetails}>
                  Finding Balance: Simple Ways To Improve Your Mental Health
                </Link>
              </h3>
              <div className="blog-info">
                <p className="blog-text">
                  <i className="isax isax-tag-user5" />
                  Admin
                </p>
                <p className="blog-text">
                  <i className="isax isax-messages-15" />
                  Comment(3)
                </p>
              </div>
              <Link
                to={all_routes.blogDetails}
                className="btn btn-white"
                aria-label="Learn More"
              >
                Learn More{" "}
                <span className="icon">
                  <i className="isax isax-arrow-right-1" />
                </span>{" "}
              </Link>
            </div>
          </div>
        </div>
        {/* Blog Item 2 */}
        <div className="col-lg-12">
          <div
            className="blog-item-fifteen dark-blog wow fadeInUp"
            data-wow-duration="2s"
          >
            <div className="blog-content">
              <Link to="#" className="blog-tag">
                Addiction &amp; Recovery
              </Link>
              <h3 className="blog-title">
                <Link to={all_routes.blogDetails}>
                  Building Emotional Strength For Our Lives Through Self Care
                </Link>
              </h3>
              <div className="blog-info">
                <p className="blog-text">
                  <i className="isax isax-tag-user5" />
                  Admin
                </p>
                <p className="blog-text">
                  <i className="isax isax-messages-15" />
                  Comment(3)
                </p>
              </div>
              <Link
                to={all_routes.blogDetails}
                className="btn btn-white"
                aria-label="Learn More"
              >
                Learn More{" "}
                <span className="icon">
                  <i className="isax isax-arrow-right-1" />
                </span>{" "}
              </Link>
            </div>
            <div className="blog-img">
              <ImageWithBasePath
                src="assets/img/blog/blog-img-5.jpg"
                alt="blog"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
        {/* Blog Item 3 */}
        <div className="col-lg-12">
          <div
            className="blog-item-fifteen mb-0 wow fadeInUp"
            data-wow-duration="2s"
          >
            <div className="blog-img">
              <ImageWithBasePath
                src="assets/img/blog/blog-img-6.jpg"
                alt="blog"
                className="img-fluid"
              />
            </div>
            <div className="blog-content">
              <Link to="#" className="blog-tag">
                Mental Health Awareness
              </Link>
              <h3 className="blog-title">
                <Link to={all_routes.blogDetails}>
                  The Importance Of Mental Health In Everyday Life Explained
                </Link>
              </h3>
              <div className="blog-info">
                <p className="blog-text">
                  <i className="isax isax-tag-user5" />
                  Admin
                </p>
                <p className="blog-text">
                  <i className="isax isax-messages-15" />
                  Comment(3)
                </p>
              </div>
              <Link
                to={all_routes.blogDetails}
                className="btn btn-white"
                aria-label="Learn More"
              >
                Learn More{" "}
                <span className="icon">
                  <i className="isax isax-arrow-right-1" />
                </span>{" "}
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* End row */}
    </div>
    <ImageWithBasePath
      src="assets/img/bg/round-element-3.svg"
      alt="round-element-1"
      className="round-element-1 img-fluid"
    />
    <ImageWithBasePath
      src="assets/img/bg/about-img-two.png"
      alt="round-element-1"
      className="round-element-2 img-fluid"
    />
    <ImageWithBasePath
      src="assets/img/bg/about-img-two.png"
      alt="round-element-1"
      className="round-element-3 img-fluid"
    />
  </section>
  {/* Start Blog Section */}
</>

  )
}

export default BlogSection